// extracted by mini-css-extract-plugin
export default {"nav":"YujbLZ","menuToggle":"mGx4LE","toggleOpen":"VaMfZ_","buttonContainer":"iFKBdR","menu":"MsXubo","pix":"L8RJUm"};